module.exports = {
  regex: {
    isoDate: /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/,
    email: /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/,
    domain: /^(?:[-A-Za-z0-9]+\.)+[A-Za-z]{2,6}$/,
    slug: /^[a-z0-9-]+$/,
  },

  generateHash () {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
  },

  isEmail (string) {
    return this.regex.email.test(string || '');
  },

  isIsoDate (string) {
    return this.regex.isoDate.test(string);
  },

  isDomain (string) {
    return this.regex.domain.test(string);
  },

  isSlug (string) {
    return this.regex.slug.test(string);
  },

  capitalize (string) { // Stackoverflow copy
    return string.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  },

  sha256(string) {
    const utf8 = new TextEncoder().encode(string);
    return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray
        .map((bytes) => bytes.toString(16).padStart(2, '0'))
        .join('');
      return hashHex;
    });
  },

  simpleHash(string) {
    let hash = 0;
    for (let i = 0, len = string.length; i < len; i++) {
        let char = string.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0;
    }
    return hash;
  }
};
